// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ceb89eef","396":"a55c6af5","453":"226e76ee","455":"ef90e41c","857":"68da8f5d","977":"2ea59beb"}[chunkId] + ".chunk.js";
};